<script setup lang="ts">

import {CurrencyDisplay, formatting, LegacyAdjustment, LegacyOrder, LegacyRmaRow} from "@hantera/portal-app";
import {computed} from "vue";

const props = defineProps<{
  order: LegacyOrder,
  row: LegacyRmaRow,
  adjustment: LegacyAdjustment
}>()

const name = computed(() => {
  return props.adjustment.orderRule?.name ?? ''
})

const sum = computed(() => {
  return props.adjustment.adjustmentTotal.div(props.row.quantity);
})

</script>

<template>
  <div class="adjustment-name" :title="name">
    {{name}}
  </div>
  <div class="adjustment-total">
    {{formatting.currency(sum, props.order.currencyCode, CurrencyDisplay.none)}}
  </div>
</template>

<style scoped>

.adjustment-name,
.adjustment-total {
  color: hsl(var(--color-text-50));
}

.adjustment-name {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.adjustment-total {
  text-align: right;
}

</style>